export default __webpack_public_path__ + "static/media/edit.29d99990.svg";